export const VALIDATE_SESSION = 'VALIDATE_SESSION';
